import React, { useEffect, useRef, useState } from 'react'
import { TicketCard } from '@app/components/index';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux'
import usePermisos from '@app/hooks/usePermisos';

const PAGE_SIZE = 20;

function TabContactoTickets({
    tickets
}) {
    const [filtro, setfiltro] = useState(tickets);
    const [filtroTK, setfiltroTK] = useState('');
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
    const sentinelRef = useRef(null);
    const permisos = usePermisos();

    useEffect(() => {
        const nextFiltro = filtroTK === ''
            ? tickets
            : tickets?.filter((tk) => tk.estado_tk === filtroTK);
        setfiltro(nextFiltro);
        setVisibleCount(PAGE_SIZE);
    }, [filtroTK, tickets])

    useEffect(() => {
        const sentinel = sentinelRef.current;
        if (!sentinel) return () => {};
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setVisibleCount((prev) => prev + PAGE_SIZE);
                }
            },
            { threshold: 0.1 }
        );
        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [filtro]);

    const visibleTickets = filtro?.slice(0, visibleCount) ?? [];
    const hasMore = visibleCount < (filtro?.length ?? 0);
    return (
        <div className="p-5">
            <div className="row">
                <Button style={{width: '100px'}} variant={filtroTK === 'ABIERTO' ? 'success' : 'outline-success'} onClick={()=>{setfiltroTK('ABIERTO')}}>Abiertos</Button>
                {permisos['ticket.update911'] &&(
                    <>
                        <Button style={{width: '100px'}} variant={filtroTK === 'PORVENCER' ? 'warning' : 'outline-warning'} onClick={()=>{setfiltroTK('PORVENCER')}}>Por Vencer</Button>
                        <Button style={{width: '100px'}} variant={filtroTK === 'VENCEHOY' ? 'danger' : 'outline-danger'} onClick={()=>{setfiltroTK('VENCEHOY')}}>Vence Hoy</Button>
                        <Button style={{width: '100px'}} variant={filtroTK === 'VENCIDO' ? 'dark' : 'outline-dark'} onClick={()=>{setfiltroTK('VENCIDO')}}>Vencidos</Button>
                    </>
                )}
                <Button style={{width: '100px'}} variant={filtroTK === 'CERRADO' ? 'dark' : 'outline-dark'} onClick={()=>{setfiltroTK('CERRADO')}}>Cerrados</Button>
                <Button style={{width: '100px'}} variant={filtroTK === '' ? 'primary' : 'outline-danger'} onClick={()=>{setfiltroTK('')}}>Todos</Button>
            <h5 className="m-2">
                {'Total Ticket Filtrados: '}
                {filtro?.length}
                {' — Mostrando '}
                {visibleTickets.length}
            </h5>
            </div>
            <div className="row">
                <div className="offset-lg-12 col-lg-12 col-md-12">
                    {
                        visibleTickets.map((ticket)=>{
                            return <TicketCard item={ticket} key={ticket.id_tk} className="mb-3" hideClickMap />
                        })
                    }
                    {hasMore && (
                        <div ref={sentinelRef} style={{ height: 40 }} />
                    )}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    user: state.auth.currentUser
})

export default connect(mapStateToProps, null)(TabContactoTickets) 